module.exports = __webpack_public_path__ + "media/img/health-033b7d9f.svg";